import colorAlpha from './color-alpha';
import clone from 'lodash/clone';
import range from 'lodash/range';

export function drawWaterColor(p, x, y, size, color, drawState = {}) {
  p.noStroke();
  let fill = drawState.fill || colorAlpha(p, color, 0.008);
  drawState.fill = fill;
  p.fill(fill);

  const EXTRA_LAYERS = 5;
  const INITIAL_DEFORMATIONS = 3;
  const EXTRA_DEFORMATIONS = 3;
  const N_SIDES = 8;

  const variances = range(N_SIDES).map(() => p.random(0.2, 0.4));
  const angle = p.TWO_PI / N_SIDES;
  let shape = [];
  const radius = size / 2;

  if (drawState.shape) {
    drawShape(drawState.shape);
    return drawState;
  }

  for (let i = 0; i < p.TWO_PI; i += angle) {
    const sx = x + p.cos(i) * radius;
    const sy = y + p.sin(i) * radius;
    shape.push([sx, sy]);
    // p.ellipse(sx, sy, 10, 10);
  }

  let clonedShape;
  for (let j = 0; j < INITIAL_DEFORMATIONS; j++) {
    shape = runDeformation(shape, variances[j]);
  }
  clonedShape = clone(shape);

  drawState.shape = shape;
  drawShape(shape);

  fill = drawState.fill || colorAlpha(p, color, 0.001);
  fill = colorAlpha(p, fill, 0.01);
  for (let j = 0; j < EXTRA_LAYERS; j++) {
    // fill = colorAlpha(p, fill, 0.01);
    p.fill(fill);
    let currentShape = clone(clonedShape);
    for (let i = 0; i < EXTRA_DEFORMATIONS; i++) {
      currentShape = runDeformation(currentShape, variances[i + 3]);
    }
    drawShape(currentShape);
  }

  function drawShape(shape) {
    p.beginShape();
    for (let i = 0; i < shape.length; i += 1) {
      p.curveVertex(shape[i][0], shape[i][1]);
    }
    p.endShape(p.CLOSE);
  }

  function runDeformation(shape, varience) {
    const newShape = [];
    for (let i = 0; i < shape.length; i++) {
      // console.log(shape[i], i)
      const [sx, sy] = shape[i];

      if (shape[i - 1]) {
        const [sx2, sy2] = shape[i - 1];
        const strokeOutPoint = runEdgeDeformation(sx, sy, sx2, sy2, varience);
        // shape.splice(i, 0, strokeOutPoint);
        newShape.push(strokeOutPoint);
        newShape.push(shape[i]);
        // i += 1;
      }

      if (i === shape.length - 1) {
        const [sx2, sy2] = shape[0];
        const strokeOutPoint = runEdgeDeformation(sx, sy, sx2, sy2, varience);
        newShape.push(shape[i]);
        newShape.push(strokeOutPoint);
        // i += 1;
      }
    }

    // console.log(newShape);
    return newShape;
  }

  function runEdgeDeformation(sx, sy, sx2, sy2, varience) {
    const edgeSize = p.dist(sx, sy, sx2, sy2);
    const initialEdgeSize = Math.sin(angle) * radius;

    const baseStrokeOut = size / 5;
    const scaleFactor = edgeSize / initialEdgeSize;
    const strokeOut =
      varience * scaleFactor * p.randomGaussian(baseStrokeOut, baseStrokeOut);
    // const strokeOut =
    //   varience * scaleFactor * p.random(-baseStrokeOut / 2, baseStrokeOut * 2);
    const midPoint = Math.max(-0.6, Math.min(2.6, p.randomGaussian(0.5, 0.3)));
    // const midPoint = Math.max(-0.6, Math.min(2.6, p.random(0, 0.8)));

    const strokeOutPosition = [
      sx + midPoint * (sx2 - sx),
      sy + midPoint * (sy2 - sy),
    ];

    const p1 = p.createVector(x, y);
    const p2 = p.createVector(strokeOutPosition[0], strokeOutPosition[1]);
    const angleBetween =
      p.randomGaussian(0.5, 0.5) * p.atan2(p2.y - p1.y, p2.x - p1.x);
    // const angleBetween = p.random(0, 1) * p.atan2(p2.y - p1.y, p2.x - p1.x);

    const strokeOutPoint = [
      strokeOutPosition[0] + Math.cos(angleBetween) * strokeOut,
      strokeOutPosition[1] + Math.sin(angleBetween) * strokeOut,
    ];

    return strokeOutPoint;
  }

  return drawState;
}

export function drawWaterColorBrush(p, x, y, size, color, drawState = {}) {
  drawWaterColor(p, x, y, size, color, drawState.w4);
  drawWaterColor(p, x, y, size, color, drawState.w4);
  drawWaterColor(p, x, y, size, color, drawState.w4);
  return {};
}

export default function sketch(p) {
  p.setup = function setup() {
    p.createCanvas(p.windowWidth, p.windowHeight);
    p.background(colorAlpha(p, 255, 1));
    drawWaterColorBrush(p, p.width / 2, p.height / 2, 200, 'red');
  };

  p.draw = function() {
    p.background(colorAlpha(p, 255, 1));
    drawWaterColorBrush(p, p.width / 2, p.height / 2, 200, 'red');

    const fps = p.frameRate();
    p.fill(0);
    p.stroke(0);
    p.text('FPS: ' + fps.toFixed(2), 10, p.height - 10);
  };

  p.touchStarted = function touchStarted() {
    p.getAudioContext().resume();
  };
}



// WEBPACK FOOTER //
// ./src/sketches/watercolor.js